import {
  BlockingDialog,
  BlockingDialogContent,
  BlockingDialogHeader,
  BlockingDialogTitle,
  BlockingDialogDescription,
} from "@/components/ui/blocking-dialog";
import { Button } from "@/components/ui/button";
import { Lock, Sparkles, Check } from "lucide-react";

interface HardPaywallModalProps {
  open: boolean;
  onLogin: () => void;
}

const HardPaywallModal = ({ open, onLogin }: HardPaywallModalProps) => {
  const features = [
    "Crie até 10 versões da sua marca",
    "Download em alta qualidade (PNG)",
    "Paleta de cores profissional (4 cores)",
    "Kit de tipografia completo (3 fontes)",
    "Fundo transparente e colorido",
    "+5 recreações extras para explorar mais opções",
  ];

  return (
    <BlockingDialog open={open}>
      <BlockingDialogContent className="sm:max-w-md rounded-2xl">
        <BlockingDialogHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-4">
            <Lock className="w-8 h-8 text-primary" />
          </div>
          <BlockingDialogTitle className="text-2xl">
            Sua marca está pronta! ✨
          </BlockingDialogTitle>
          <BlockingDialogDescription className="text-base mt-2">
            Faça login para desbloquear todos os ficheiros profissionais por apenas R$ 59,90.
          </BlockingDialogDescription>
        </BlockingDialogHeader>

        <div className="space-y-4 mt-6">
          <div className="bg-muted/30 rounded-2xl p-5 space-y-3">
            <p className="font-medium text-sm text-foreground flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-primary" />
              O que você recebe:
            </p>
            <ul className="space-y-2">
              {features.map((feature) => (
                <li key={feature} className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Check className="w-4 h-4 text-primary flex-shrink-0" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          <Button 
            onClick={onLogin} 
            className="w-full h-14 text-lg font-semibold gap-2 bg-gradient-to-r from-primary to-emerald-500 hover:from-primary/90 hover:to-emerald-500/90 shadow-xl shadow-primary/30 hover:scale-[1.02] transition-all duration-300"
          >
            Desbloquear por R$ 59,90
          </Button>

          <p className="text-xs text-center text-muted-foreground">
            Já tem uma conta? Clique acima para fazer login e continuar criando.
          </p>
        </div>
      </BlockingDialogContent>
    </BlockingDialog>
  );
};

export default HardPaywallModal;
